<template>
  <b-container>
    <el-tabs v-model="activeName">
    <!--  <el-tab-pane label="仲裁指南" name="first">
        <guide />
      </el-tab-pane>-->
      <el-tab-pane label="示范条款" name="second">
        <demo />
      </el-tab-pane>
      <el-tab-pane label="仲裁规则" name="third">
        <rule />
      </el-tab-pane>
      <el-tab-pane label="立案须知" name="know">
        <know />
      </el-tab-pane>
      <el-tab-pane label="费用计算" name="fifth">
        <count />
      </el-tab-pane>
      <el-tab-pane label="流程指引" name="lczy">
        <guide />
      </el-tab-pane>
    </el-tabs>
  </b-container>
</template>

<script>
import guide from './components/guide'
import demo from './components/demo'
import rule from './components/rule'
import manage from './components/manage'
import count from './components/count'
import bookType from './components/bookType'
import know from './components/know'
export default {
  components: {
    guide,
    demo,
    rule,
    manage,
    count,
    know,
    bookType
  },
  data () {
    return {
      activeName: this.$route.query.active || 'second'
    }
  },
  created() {
    console.log(this.$route.params)
  }
}
</script>

<style scoped>
  .el-tabs {
    padding: 14px 8px 24px;
  }
  .el-tab-pane {
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/guide/guide.vue